export default "__VITE_ASSET__LTZXI33c__"